export default __webpack_public_path__ + "static/media/03.08e078e7.jpg";